import { LitElement, html, css } from "lit-element";

import "@stofloos/components/atoms/inputs/input-simple";
import "@stofloos/components/atoms/buttons/button-submit";
import "@stofloos/components/atoms/loaders/sw-fullscreen-spinner";
import { clearForm, formToJSON, getFormElements, validateForm } from "@stofloos/utils/sw-constants";
import { store } from "@stofloos/stores/store";
import { createObject } from "@stofloos/actions/crud";
import { showToast } from "@stofloos/actions/toast";
import { changePage } from "@stofloos/actions/app";
import { initRequest } from "@stofloos/actions/requests";
import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";

// language=CSS
const style = css`
	:host {
		position: relative;
	}
	input-simple {
		margin-top: 10px;
		border-radius: 50%;
		box-shadow: 0 0 90px var(--shadow-color);
		width: 100%;
		--sw-input-simple-padding: 0 50px 0 20px;
		--input-simple-border-radius: 25px;
	}

	sw-icon {
		position: absolute;
		cursor: pointer;
		top: 20px;
		right: 20px;
		--sw-icon-color: var(--app-accent);
	}
`;
export class InputSubscribe extends LitElement {
	static get styles() {
		return [LayoutFlex, style];
	}

	static get properties() {
		return {
			label: { type: String },
			formElement: { type: Object },
			endpoint: { type: String },
			callback: { type: Object },
			id: { type: String },
			name: { type: String },
			data: { type: Object },
			disabled: { type: Boolean },
			isLoading: { type: Boolean }
		};
	}

	constructor() {
		super();
	}

	render() {
		return html`
			<sw-fullscreen-spinner ?active="${this.isLoading}"></sw-fullscreen-spinner>
			<form class="layout horizontal">
				<input-simple type="text" hidden value="newsletter" name="type"></input-simple>
				<input-simple label="naam" required round type="name" name="data.name"></input-simple>
				<input-simple label="email" required round type="email" name="${this.name}"></input-simple>
				<sw-icon icon="paper-plane" @click="${() => this.createObject()}"></sw-icon>
			</form>
		`;
	}

	createObject(){
		const form = this.formElement.querySelector("form");
		const formElements = getFormElements(form);

		if (!validateForm(formElements)) {
			return;
		}

		const data = formToJSON(formElements);

		this.isLoading = true;
		store
			.dispatch(createObject(this.requestId, data))
			.then(response => {
				this.isLoading = false;
				store.dispatch(showToast(this.callback.message.success));
				store.dispatch(changePage(this.callback.url));
				clearForm(formElements);
			})
			.catch(response => {
				this.isLoading = false;
				store.dispatch(showToast(this.callback.message.error));
			});
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);

		this.requestId = this.endpoint;
		store.dispatch(initRequest(this.requestId, this.endpoint));
	}
}

customElements.define("input-subscribe", InputSubscribe);
